export const SET_STEP = 'steps/SET_STEP';
export const ADD_PAGE_VISITED = 'steps/ADD_PAGE_VISITED';
export const ADD_PAGE_SUBMITTED = 'steps/ADD_PAGE_SUBMITTED';
export const REMOVE_SUBMITTED_PAGE = 'steps/REMOVE_SUBMITTED_PAGE';
export const CLEAR_STEPS = 'steps/CLEAR_STEPS';
